import api from "../apiConfig";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getAll(data) {
    let params = "";
    if (data) {
      Object.keys(data).forEach((key) => {
        params += `${key}=${data[key]}&`;
      });
    }
    return api.get(`/api/v1/department?${params}`);
  },

  list() {
    return api.get(`/api/v1/department-list`);
  },
  getById(id) {
    return api.get(`/api/v1/department/${id}`);
  },
  update(id, data) {
    return api.put(`/api/v1/department/${id}`, data);
  },
  create(data) {
    return api.post(`/api/v1/department`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  delete(id) {
    return api.delete(`/api/v1/department/${id}`);
  },
  myDepartmentEmployees() {
    // return api.get("/api/v1/my-department-employee");
    return api.get("/api/v1/my-employee");
  },
};
